<template>
  <div>
    <v-card class="pa-10 ma-16 panel" elevation="6">
      <p class="mb-10 headline text-center">404 Not Found</p>
      <p class="mt-0 mb-0 text-center">申し訳ございません。お探しのページが見つかりませんでした。</p>
      <p class="mt-0 mb-0 text-center">お探しのページは、削除されたか、名前が変更された可能性があります。</p>
      <p class="mt-0 mb-15 text-center">お手数をお掛け致しますが、下のボタンから画面遷移の上再度やりなおしをお願い致します。</p>
      <div class="text-center">
        <v-btn
          class="home-btn"
          rounded
          elevation="6"
          :to="$store.getters['user/homePath']"
        >ホーム画面へ</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  computed: {
    isDevMode() {
      return process.env.NODE_ENV === 'development'
    },
    params() {
      return this.$route.params
    },
  },
}
</script>

<style lang="stylus" scoped>
.panel
  min-height 70vh

.home-btn
  background-image linear-gradient(to right, #5192ce, #2978b6 30%, #118ec6)
  color white
  font-weight bold

.debug
  background-color #ece9e6
  min-height 250px
  color #616161
</style>
